import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { portfoliosRoutes } from './routes';
export class Portfolios {
  constructor() {
    _defineProperty(this, "routes", portfoliosRoutes);
  }
  async getExistingPortfolios(options) {
    const resp = await requestService('property').get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPortfolio(data, options) {
    const resp = await requestService('property').get(this.routes.portfoliosId(data.portfolioId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createPortfolio(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrl, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePortfolio(data, options) {
    const resp = await requestService('property').put(this.routes.portfoliosId(data.portfolioId), {
      name: data.name
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deletePortfolio(data, options) {
    const resp = await requestService('property').delete(this.routes.portfoliosId(data.portfolioId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPortfoliosDashboard(options) {
    const resp = await requestService('aggregate').get(this.routes.dashboard, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async transferPortfolios(data, options) {
    const resp = await requestService('property').post(this.routes.transfer, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async editPropertyPortfoliosRelationship(data, options) {
    const resp = await requestService('property').put(this.routes.editPropertyPortfoliosRelationship(data.propertyId), {
      portfolioIds: data.portfolioIds
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}